<div class="contact-page section-b-space p-3" style="background-image: none;">
    <div class="container">
        <div class="col-lg-12 text-end">
            <button type="button" (click)="closeModal()" style="background: transparent; border: none;
  cursor: pointer; font-size: 14px; padding: 0; line-height: 1; position: absolute;
  top: 8px; right: 8px; pointer-events: auto; z-index: 1001;">
                <i class="fa fa-times" aria-hidden="true"></i>
            </button>
        </div>
        <div class="col-lg-12">
            Gentili Clienti, <br><br>
            Nell'imminenza delle festività i Corrieri che utilizziamo per la spedizione non
            garantiscono la consueta rapidità.<br>
            Noi al Caseificio Soragna prepariamo le spedizioni nel più breve
            tempo possibile, tuttavia potreste ricevere la merce con un po' di ritardo rispetto
            alla normale tempistica.<br>
            Attraverso il link alla spedizione che inviamo per mail potete comunque controllare
            lo stato della consegna ed eventualmente segnalarci eventuali prolungati ritardi.
            <br><br>
            Grazie per la comprensione!
        </div>

    </div>
</div>